import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Create Customer API Call
 * @param {Object} customerData - { first_name, last_name, email, mobile_country_code, mobile_number, password }
 * @returns {Promise<Object>} - Response data from the API
 */
export const createCustomer = async (customerData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.CREATE_CUSTOMER, customerData);
    
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
